<template lang="pug">
  div
    p.text-center Admins de la conversación
    b-input-group.mb-3(size="sm")
      b-form-input(placeholder="Buscar admin...", v-model="search", type="search")
      b-input-group-append
        b-input-group-text
          search-icon.text-secondary.icon-sm
    b-card.no-shadow.bg-light.overflow-y
      .text-center.text-help(v-if="!parsedAdmins.length") No hay admins para mostrar
      b-form-group(v-else)
        b-form-checkbox-group(v-model="conversation_admins", stacked, :options="parsedAdmins", @change="changed")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')

import debounce from 'lodash.debounce'

export default {
  data () {
    return {
      filters_open: false,
      conversation_admins: [],
      search: ''
    }
  },
  computed: {
    ...accountController.mapState({
      state_admins: state => state.admins
    }),
    parsedAdmins () {
      return this.state_admins.map(a => {
        return {
          text: `${a.email}`,
          value: {
            title: `${a.first_name} ${a.last_name}`,
            email: `${a.email}`,
            admin_id: a.admin_id
          }
        }
      }).filter(a => {
        if (!this.search) return true
        return (a.value.title || '').toLowerCase().indexOf(this.search) > -1 || (a.value.email || '').toLowerCase().indexOf(this.search) > -1
      })
    },
  },
  methods: {
    ...mapActions(['conversation/get', 'conversation/update']),
    getConversation () {
      let self = this

      this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            for (let admin of res.resource.admin_ids.filter(a => a != undefined)) {
              let object = self.state_admins.find(l => l.admin_id == admin)
              if (object) {
                self.conversation_admins.push({
                  title: `${object.first_name} ${object.last_name}`,
                  email: `${object.email}`,
                  admin_id: object.admin_id
                })
              }
            }
          }
        }
      })
    },
    updateConversation: debounce(function () {
      let self = this
      // this.showLoadingScreen()

      this['conversation/update']({
        conversation_id: self.$route.params.conversation_id,
        admin_ids: self.conversation_admins.map(a => a.admin_id),
        callback: res => {
          this.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Admins actualizados')
          }
        }
      })
    }, 700),
    changed () {
      let self = this
      self.updateConversation()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getConversation()
    })
  }
}
</script>

<style lang="scss" scoped>
  .scrollable-container-sm {
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
  }

  .collapse-icon {
    transition: 0.3s;
  }

  .upsidedown {
    transform: rotate(-180deg);
  }
</style>
